import React, { useEffect, useState } from "react";
import "./Success.css";
import { useLocation } from "react-router-dom";
import { baseUrl } from "../../Config";
import axios from "axios";

const Success = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const storedData = JSON.parse(
    localStorage.getItem("checkoutresponse") || "{}"
  );
  const successUrl = storedData?.merchantSuccessUrl;

  const [countdown, setCountdown] = useState(10); // ⏳ 10 seconds countdown

  const requestBody = {
    err_Code: params.get("err_code") || null,
    err_Msg: params.get("err_msg") || null,
    transaction_Id: params.get("transaction_id") || null,
    basket_Id: params.get("basket_id") || null,
    order_Date: params.get("order_date") || null,
    rdv_Message_Key: params.get("Rdv_Message_Key") || null,
    response_Key: params.get("Response_Key") || null,
    paymentType: params.get("PaymentType") || null,
    paymentName: params.get("PaymentName") || null,
    validation_Hash: params.get("validation_hash") || null,
    transaction_Amount: params.get("transaction_amount") || null,
    merchant_Amount: params.get("merchant_amount") || null,
    discounted_Amount: params.get("discounted_amount") || null,
    issuer_Name: params.get("issuer_name") || null,
    transaction_Currency: params.get("transaction_currency") || null,
    billNumber: params.get("BillNumber") || null,
    customerId: params.get("CustomerId") || null,
    recurring_Txn: params.get("Recurring_txn") || null,
    additional_Value: params.get("additional_value") || null,
    additional_Fee: params.get("additional_fee") || null,
    metaData: params.get("metaData") || null,
  };

  const validatePayment = async () => {
    try {
      const res = await axios.put(
        `${baseUrl}api/Merchant/UATPayment`,
        requestBody
      );
      if (res.status === 200 && successUrl) {
        const interval = setInterval(() => {
          setCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              window.location.href = successUrl;
            }
            return prev - 1;
          });
        }, 1000);
      }
    } catch (error) {
      console.error("Validation failed", error);
    }
  };

  useEffect(() => {
    if (search) {
      validatePayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]); // run only once

  const handleBackClick = () => {
    window.location.href = successUrl;
  };

  return (
    <div className="success-container">
      <div className="success-box">
        <div className="success-icon">✔</div>
        <h1 className="success-heading">Thank You!</h1>
        <p>Your payment has been received successfully.</p>
        <p>
          Redirecting to your portal in {countdown} second
          {countdown !== 1 ? "s" : ""}...
        </p>
        <button
          disabled={[...params.entries()].length === 0}
          className="success-button"
          onClick={handleBackClick}
        >
          Back to Merchant
        </button>
      </div>
    </div>
  );
};

export default Success;
